module.exports = __webpack_public_path__ + "img/05.51b33136.svg";